import { render, staticRenderFns } from "./LogoutMenuModal.vue?vue&type=template&id=4a127e96"
import script from "./LogoutMenuModal.vue?vue&type=script&lang=js"
export * from "./LogoutMenuModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports